function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEventPartyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.05 9.425c0-.05 0-.375.3-.875.275-.45.6-.625.6-.625h-.025c.35-.15.6-.5.6-.925 0-.55-.45-1-1-1-.15 0-.275.025-.4.075l-.014.007c-.147.072-.933.456-1.511 1.443-.525.9-.55 1.65-.55 1.875v.05c.025.525.45.95 1 .95.55.025 1-.425 1-.975z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4 30l-2.2-10.275c-1.275-.45-2.65-1.8-3.625-3.075-1.6-2.125-2.525-4.475-2.525-6.45 0-4.525 3.15-8.2 7-8.2s7 3.675 6.975 8.2c0 2.225-1.15 4.9-3.1 7.15-.375.45-1.125 1.25-2 1.825l1.925 1.65-1.3 1.525-.9-.775L15.45 30H13.4zm3.65-19.8c0-3.425-2.25-6.2-5-6.2s-5 2.775-5 6.2c0 3.7 3.975 7.7 5 7.7.25 0 1.175-.475 2.375-1.85 1.275-1.45 2.625-3.775 2.625-5.85z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.828 9.686a.2.2 0 00.349.003l.883-1.554a.2.2 0 01.075-.075l1.554-.883a.2.2 0 00-.003-.35l-1.548-.85a.2.2 0 01-.079-.077l-.881-1.581a.2.2 0 00-.351.002l-.849 1.576a.2.2 0 01-.08.081l-1.577.849a.2.2 0 00-.002.35l1.58.882a.2.2 0 01.079.079l.85 1.548z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.775 22.525c.275.375 1.05 1.3 1.925 1.875L21.225 30H23.3l1.1-4.55 2 1.625 1.25-1.55-1.825-1.475c.633-.516 1.134-1.12 1.4-1.44l.05-.06c1.125-1.475 1.775-3.125 1.775-4.525 0-3.225-2.25-5.85-5.025-5.85C21.25 12.175 19 14.775 19 18c0 1.4.65 3.05 1.775 4.525zm3.25-8.375c1.675 0 3.025 1.725 3.025 3.85 0 2.175-2.3 4.65-3.025 4.85C23.3 22.65 21 20.2 21 18c0-2.125 1.35-3.85 3.025-3.85z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.176 25.673a.2.2 0 01-.352 0l-.846-1.57a.2.2 0 00-.08-.081l-1.571-.846a.2.2 0 010-.352l1.57-.846a.2.2 0 00.081-.08l.846-1.571a.2.2 0 01.352 0l.845 1.57a.2.2 0 00.082.081l1.57.846a.2.2 0 010 .352l-1.57.846a.2.2 0 00-.082.08l-.845 1.571z",
    fill: props.color
  }));
}

export default SvgIconEventPartyFilled;